import {
    GET_COURIER_BY_ADMIN_REQUEST,
    GET_COURIER_BY_ADMIN_SUCCESS,
    GET_COURIER_BY_ADMIN_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const getCourierListByAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_COURIER_BY_ADMIN_REQUEST:
            return {
                error: "",
                loading: true,
                data: [],
            };

        case GET_COURIER_BY_ADMIN_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case GET_COURIER_BY_ADMIN_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
}

export default getCourierListByAdminReducer;
